import React, { FC } from 'react'

import { ColorTypes, Span } from '@afterpaytouch/core'

interface Props {
  length?: number
  error?: boolean
  disabled?: boolean
  color: ColorTypes
}

const MASK = '•'

export const CardAsterisk: FC<Props> = ({ length = 4, error = false, disabled = false, color }) => {
  if (length < 1) {
    return null
  }

  const maskColor: ColorTypes = error ? 'Danger' : disabled ? 'Disabled' : color

  const asterisks = MASK.repeat(length)
  return (
    <Span aria-hidden color={maskColor} size='XS'>
      {asterisks}
    </Span>
  )
}
